import resetReduxAction from 'modules/redux/actions/reset'
import { BANNER_ACTION, BANNER_DOMAIN } from 'modules/banner/constants'

function closeBannerAction () {
  return (dispatch, getState) => {
    const banner = getState().banner
    // If there is no data to reset, noop
    if (!banner.message) {
      return
    }
    dispatch(
      resetReduxAction({
        type: BANNER_ACTION.RESET,
        payload: {
          path: BANNER_DOMAIN
        }
      })
    )
  }
}

export default closeBannerAction
